{
  "enum": {
    "J5RegistryV1ArtifactStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "J5RegistryV1Type": {
      "DIAGRAM": "Diagram",
      "DOCUMENT": "Document",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "J5RegistryV1ArtifactQueryServiceArtifactListFilterableFields": {
      "bundle": "Bundle",
      "data": {
        "type": "Type"
      },
      "name": "Name",
      "owner": "Owner",
      "status": "Status",
      "version": "Version"
    }
  },
  "oneOf": {
    "J5RegistryV1ArtifactEventType": {
      "uploaded": "Uploaded"
    }
  },
  "searchEnum": {
    "J5RegistryV1ArtifactQueryServiceArtifactListSearchableFields": {
      "data": {
        "contentType": "Content Type"
      }
    }
  },
  "sortEnum": {
    "J5RegistryV1ArtifactQueryServiceArtifactListSortableFields": {
      "data": {
        "bundleIndex": "Bundle Index"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}